"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priorityTierInputSchema = exports.bookingReminderRequestSchema = exports.notificationRequestSchema = void 0;
/**
 * Shared request fragments reused across more than one Appointment
 * endpoint contract — declared once here rather than duplicated per
 * category file, the same "reuse over duplication" discipline
 * `docs/PATIENT-API-CONTRACT-GUIDE.md` §4 established for Patient
 * Identity's own contracts (e.g. its `contactSchema`/`addressSchema`
 * fragments in `registration.request.ts`).
 */
const zod_1 = require("zod");
/** Mirrors `core/notification`'s `NotificationRequest` (backend, frozen, Stage 1) — declared independently, no import of backend source. */
exports.notificationRequestSchema = zod_1.z.object({
    channel: zod_1.z.enum(['email', 'sms', 'whatsapp']),
    to: zod_1.z.string().min(1),
    subject: zod_1.z.string().optional(),
    body: zod_1.z.string().min(1),
});
/** Mirrors `BookingApplicationService`'s `BookingReminderRequest` (backend, frozen, Stage 5B.4). */
exports.bookingReminderRequestSchema = zod_1.z.object({
    channelId: zod_1.z.string().uuid(),
    scheduledFor: zod_1.z.coerce.date(),
});
/** Mirrors `_shared-service`'s `PriorityTierInput` (backend, frozen, Stage 5B.3). */
exports.priorityTierInputSchema = zod_1.z.object({
    sessionCategory: zod_1.z.enum(['GENERAL', 'EMERGENCY', 'TELEMEDICINE']).optional(),
    isVip: zod_1.z.boolean().optional(),
    isEmergency: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=appointment-common.request.js.map